import { computed, signal } from '@preact/signals-react';

import { CompanyModel } from '@/entities/company/model';
import { CompanyDocumentType } from '@/entities/company/model/CompanyDocumentModel';

const company = signal<CompanyModel | null>(null);

export const companyStore = {
  company,
  setCompany(c: CompanyModel) {
    this.company.value = c;
  },
  offerDocument: computed(() =>
    company.value?.documents?.find(
      (d) => d.documentType === CompanyDocumentType.Offer
    )
  ),
  agreementDocument: computed(() =>
    company.value?.documents?.find(
      (d) => d.documentType === CompanyDocumentType.Agreement
    )
  ),
};
